import { Chip, Divider, Stack, Typography } from '@mui/material'
import numeral from 'numeral'
import { Fragment } from 'react'

import { Maybe } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type PaymentCellProps = {
  billingStatements?:
    | {
        statements: {
          label: Maybe<string> | undefined
          value: string
        }[]
        totalPrice: number
      }[]
    | undefined
  choiceLength?: number
}

export const PaymentCell: Cell<PaymentCellProps> = ({
  billingStatements,
  choiceLength = 1,
}) => {
  const { t } = useTranslation('lotteryConfirmation')

  return (
    <CellFrame sx={{ pt: 3, pb: 5 }}>
      <Stack sx={{ px: 2, py: 1, bgcolor: 'grey.50' }}>
        <Typography variant="h5" color="text.secondary">
          {t('totalPaymentAmount', 'お支払い総額')}
        </Typography>
      </Stack>
      <Stack spacing={5} sx={{ pt: 3 }}>
        {billingStatements?.map((stmt, index) => {
          return (
            <Stack key={index}>
              {choiceLength > 1 && (
                <Chip
                  variant="outlined"
                  label={
                    <Typography variant="overline">
                      {t('preference', { index: index + 1 })}
                    </Typography>
                  }
                  sx={{
                    bgcolor: 'white',
                    p: 0,
                    height: 20,
                    '.MuiChip-label': { p: 1 },
                  }}
                />
              )}
              {stmt?.statements?.map(({ value, label }, subIndex) => (
                <Fragment key={subIndex}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{ py: 2 }}
                  >
                    <Typography variant="subtitle1" color="text.secondary">
                      {label}
                    </Typography>
                    <Typography variant="body2">{value}</Typography>
                  </Stack>
                  <Divider />
                </Fragment>
              ))}
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ py: 2 }}
              >
                <Typography variant="subtitle1" color="text.secondary">
                  {t('total')}
                </Typography>
                <Typography variant="h6">
                  ￥{numeral(stmt.totalPrice).format('0,0')}
                </Typography>
              </Stack>
            </Stack>
          )
        })}
      </Stack>
    </CellFrame>
  )
}
